import * as R from 'ramda'
import { SET_FEEDBACK_FILTER } from '../../actions'

const initialState = {
  has_comment: false,
  text: '',
  team_member_identifier: [],
  customer_name: [],
  customer_company: [],
  sentiment: [],
  metric: [],
  source: [],
  survey_token: [],
  agent_group: [],
  board: [],
  department: [],
}

export const initialFeedbackFilterState = initialState

const feedbackFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEEDBACK_FILTER: {
      if (R.isEmpty(action.query)) {
        return initialState
      }
      return R.merge(initialState, action.query)
    }
    default:
      return state
  }
}

export default feedbackFilterReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/feedbackFilter.js